import { HttpService } from "@/core/services/http.service";

import { BaseReq, PaginationReq, PaginationResp } from "@/core/interface";

export class TicketAssignReq extends BaseReq {
  acceptUserId: string = ""; // 接单人ID
  operationType: number = 0; // 操作类型：0-派单 1-转单
  remark: string = ""; // 备注
  acceptUserName: string = ""; //接单人姓名
}
export class TicketAssignService {
  static useTicketAssignApi() {
    const api = (id, data,type) =>
      HttpService.axios({
        method: "POST",
        url: `/ticket${type=='yw'?'/maintenance':''}/cancel/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
}
